import { updateUserDetails } from '@store/slices/authSlice';
import axios from 'axios';
import { endpoints } from '@api/apis';
import {
  getJourneyFromUserResponse,
  getPlatformFromUserResponse,
  refreshContactNumbersAfterUserApi,
} from '@app/services/contactNumbersBridge';
import { reconcileFeatureFlagUser } from '@app/services/featureFlag';
import { store } from '@store/newstore';

const promiseFetchUserInfo = async () => {
  let response: any;
  try {
    const res = await axios.post(endpoints.userInfo, {
      onboardingPartnerCode: '',
    });
    response = res.data;
    store.dispatch(updateUserDetails(response));
    // Drop any A/B cache that belongs to a different user (e.g. the partner
    // platform swapped the user inside the web iframe).
    if (response?.user?.userId) {
      store.dispatch(
        reconcileFeatureFlagUser({ userId: response.user.userId }),
      );
    }
    return response;
  } catch (err) {
    console.log('err', err);
    throw err;
  } finally {
    await refreshContactNumbersAfterUserApi(
      response
        ? {
            journey: getJourneyFromUserResponse(response),
            platform: getPlatformFromUserResponse(response),
          }
        : undefined,
    );
  }
};

export default promiseFetchUserInfo;
